module.exports = __webpack_public_path__ + "static/media/table_background_high_med.e59bacf1.jpg";